import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const DeleteButton = styled.button`
  position: absolute;
  z-index: 20;
  top: -13px;
  right: -13px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.brandBlue};
  color: ${colors.white};
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in;

  &:hover {
    background-color: ${colors.brandGreen};
  }
`;
